<div class="container-fluid p-0">
  <div class="row g-0 main-container">
    <!-- LEFT: Cases List -->
    <div class="col-lg-4 cases-sidebar">
      <!--
        Title and count share a line, and each filter group is one labelled row.

        The count used to sit on its own line under the heading, restating
        "Total Cases" next to a number that is self-evidently a case count in a
        panel titled Cases. Pairing it with the title reclaims that line and puts
        the number where the eye already is.
      -->
      <div class="cases-sidebar-header">
        <div class="header-title-row">
          <h5 class="header-title">Cases</h5>
          <app-case-stats-bar
            [totalCount]="casesService.totalCount()"
            [filteredCount]="casesService.filteredCount()"
            [activePriorityFilter]="casesService.activePriorityFilter()"
            [activeStatusFilter]="casesService.activeStatusFilter()"
          />
        </div>

        <div class="filter-group">
          <span class="filter-label" id="cases-priority-label">Priority</span>
          <app-case-filter-chips
            aria-labelledby="cases-priority-label"
            [filters]="priorityFilters"
            [activeValue]="casesService.activePriorityFilter()"
            (filterChanged)="onPriorityFilter($event)"
          />
        </div>

        <div class="filter-group">
          <span class="filter-label" id="cases-status-label">Status</span>
          <app-case-filter-chips
            aria-labelledby="cases-status-label"
            [filters]="statusFilters"
            [activeValue]="casesService.activeStatusFilter()"
            (filterChanged)="onStatusFilter($event)"
          />
        </div>
      </div>

      <div class="cases-list" #casesList (scroll)="onListScroll($event)">
        @if (casesService.isLoading()) {
          <div class="d-flex justify-content-center py-5">
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        } @else if (casesService.error()) {
          <div class="text-center py-5">
            <p class="text-muted">{{ casesService.error() }}</p>
            <button class="btn btn-outline-primary btn-sm" (click)="casesService.loadTickets(null)">
              Retry
            </button>
          </div>
        } @else if (casesService.filteredTickets().length === 0) {
          <div class="text-center py-5">
            <p class="text-muted">No cases match the current filters.</p>
          </div>
        } @else {
          @for (ticket of casesService.filteredTickets(); track ticket.request_id) {
            <app-case-card
              [ticket]="ticket"
              [active]="casesService.selectedTicketId() === ticket.request_id"
              (cardClicked)="onCardClicked($event)"
            />
          }

          <!-- Infinite scroll: loading more indicator -->
          @if (casesService.isLoadingMore()) {
            <div class="d-flex justify-content-center py-3">
              <div class="spinner-border spinner-border-sm text-muted" role="status">
                <span class="visually-hidden">Loading more...</span>
              </div>
            </div>
          }

          <!-- Show count when all loaded -->
          @if (!casesService.hasMore() && casesService.filteredTickets().length > 0) {
            <div class="text-center py-2">
              <span class="text-muted small">
                All {{ casesService.totalCount() }} cases loaded
              </span>
            </div>
          }
        }
      </div>
    </div>

    <!-- RIGHT: Case Detail -->
    <div class="col-lg-8 detail-container">
      @if (casesService.selectedTicket(); as selected) {
        <app-case-detail-panel [ticket]="selected" />
      } @else {
        <div class="empty-state d-flex flex-column align-items-center justify-content-center h-100 text-muted">
          <h6>Select a case to view details</h6>
          <p class="small">Choose a case from the list on the left</p>
        </div>
      }
    </div>
  </div>
</div>
